export const bannerNewsletterModule = {
  name: 'Banner Newsletter',
};
